import React, { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getEllipsedString, getFormattedDateTime, resetSelectedChannelUnreadMsgCount } from '../../../../../config/utils'
import dayjs from 'dayjs'
import { Avatar, Spin } from 'antd'
import ChatInput from '../ChatInput'
import useChatApi from '../../../../../config/hooks/api/chats/useChatApi'
import { setAppLoading, setMessage } from '../../../../../store/common/generalSlice'
import { LoadingOutlined } from '@ant-design/icons'
import { getSocketInstance } from '../../../../../config/hooks/utility/socket'
import skypeMp3 from '../../../../../assets/audios/skype-notification.mp3'
import Prompt from '../../../../../components/Prompt'
import Modal from '../../../../../components/Modal'
import { IoCheckmarkDoneSharp } from 'react-icons/io5'

const ChatMessages = ({
    selectedChatMemberData = null,
    chatData = null, //selected chat data from chatlist
    isModal = false,
    refreshData,
    resetRefreshData,
    handleBlockedChannel,
    isMessageSenderBlocked
}) => {
    const dispatch = useDispatch()
    const { getChatMessagesByChannelId, createChatChannel, acceptChatInvite, blockUser } = useChatApi()

    const [dateTimeFormattedMsgs, setDateTimeFormattedMsgs] = useState({})
    // const [message, setMessagee] = useState(null)
    const [oldMessages, setOldMessages] = useState([])
    const [offset, setOffset] = useState(0)
    const [getUpdatedFeeds, setGetUpdatedFeeds] = useState(true)
    const [channelData, setChannelData] = useState(null)
    const [loading, setLoading] = useState(false)
    const [hasMore, setHasMore] = useState(true);
    const [loadMore, setLoadMore] = useState(false);
    const [selectedChatMember, setSelectedChatMember] = useState(null)
    const [isReceipientBlocked, setIsReceipientBlocked] = useState(false) //other user(msg receiver)
    const [isSenderBlocked, setIsSenderBlocked] = useState(false) //my user(msg sender)
    const [refresh, setRefresh] = useState(0)
    const [modalLoading, setModalLoading] = useState(false)
    const [promptOpen, setPromptOpen] = useState(false)

    const msgBodyRef = useRef(null)
    const offsetRef = useRef(0); // Define a ref to track offset value
    const oldMessagesRef = useRef([]);

    const socket = getSocketInstance();

    const user = useSelector(state => state?.auth?.loggedInUser)
    const limit = 10
    const currentDate = getFormattedDateTime(new Date(), 'YYYY-MM-DD')
    const unlockUserPromptMessage = 'Are you sure you want to unblock this user?'

    // Sort the keys by date
    const sortObjectKeysByDate = (keys) => {
        return Object.keys(keys)
            .sort((a, b) => dayjs(a).diff(dayjs(b)))
            .reduce((acc, key) => {
                acc[key] = keys[key];
                return acc;
            }, {});
    }

    const formatMessagesByDate = () => {
        if (oldMessages && oldMessages?.length) {
            const dates = []
            const datedMsgs = {}

            const msgs = [...oldMessages]

            for (let i = 0; i < msgs.length; i++) {
                if (!dates.includes(getFormattedDateTime(msgs[i].createdAt, 'YYYY-MM-DD'))) {
                    dates.push(getFormattedDateTime(msgs[i].createdAt, 'YYYY-MM-DD'))
                }
            }

            if (dates.length) {
                for (let j = 0; j < dates.length; j++) {
                    const msgsByDate = msgs.filter(e => getFormattedDateTime(e.createdAt, 'YYYY-MM-DD') === getFormattedDateTime(dates[j], 'YYYY-MM-DD'))
                    datedMsgs[dates[j]] = sortArrByTime(msgsByDate)
                }
                const dateSortedMsgs = sortObjectKeysByDate(datedMsgs)
                if (dateSortedMsgs) {
                    setDateTimeFormattedMsgs(dateSortedMsgs)
                }
            }
        }
    }

    const sortArrByTime = (arr) => {
        if (!arr) return []
        // Sort the array by datetime (ascending order)
        const sortedEvents = arr.slice().sort((a, b) => {
            const dateA = dayjs(a.createdAt);
            const dateB = dayjs(b.createdAt);

            return dateA.isAfter(dateB) ? 1 : -1;  // Return 1 if dateA is after dateB, else -1
        });
        return sortedEvents
    }

    const createNewChatChannel = async () => {
        try {
            const response = await createChatChannel({
                otherMemberId: chatData?.memberId || selectedChatMemberData?.id
            })
            if (response) {
                if (response?.data?.chatChannel) setChannelData(response?.data?.chatChannel)
            }
        } catch (error) {
            console.log(error)
        }
    }

    const getReceipientData = (chatMembers) => {
        if (chatMembers && chatMembers.length) {
            return chatMembers.filter(e => e.memberId !== user?.id)[0]
        }
    }

    const handleBlockUnblockUser = async () => {
        let receipient = selectedChatMember?.id
        if (!receipient) {
            receipient = getReceipientData(selectedChatMember?.chatMembers)?.memberId
            if (!receipient) return
        }

        const response = await blockUser({
            otherUserId: receipient
        })
        if (response) {
            setIsReceipientBlocked(!response?.data?.blockedUser?.id ? false : true)
            setRefresh(prev => ++prev)
            dispatch(setMessage(response?.data?.message))
        }
    }


    const handleAcceptUserChatRequest = async () => {
        try {
            if ((!isModal && !selectedChatMember) || isModal && !channelData) return false

            dispatch(setAppLoading(true))

            let userChatMember;
            if(isModal){
                userChatMember = channelData?.memberId === user?.id ? channelData?.id : null
            }
            else{
                userChatMember = selectedChatMember?.chatMembers.filter(e => e?.memberId === user?.id)[0]?.id
            }

            if (userChatMember) {
                const response = await acceptChatInvite(userChatMember)
                if (response){
                    await createNewChatChannel()

                    dispatch(setMessage(response?.data?.message))
                    dispatch(setAppLoading(false))
                } 
            }
            else{
                dispatch(setAppLoading(false))
            }
        } catch (error) {
            console.log(error)
        }
    }

    const scrollToBottom = (custom) => {
        setTimeout(() => {
            if (msgBodyRef && msgBodyRef.current) {
                msgBodyRef.current.scrollTo({
                    top: custom ? custom : msgBodyRef.current.scrollHeight,
                    behavior: 'smooth'
                });
            }
        }, 500);
    }

    const getMessageId = () => {
        const ascSorted = [...oldMessagesRef.current].sort((a, b) => a.id - b.id);
        return ascSorted[ascSorted.length - 1]?.id + 1 || 1;
    }

    const handleUserMsgInput = (data) => {
        if (oldMessages.length) {
            setOldMessages((prev) => [
                ...prev, 
                { ...data, id: getMessageId(), status: false }
            ])
        }
        else {
            setOldMessages([{ ...data, id: 1 }])
        }
        scrollToBottom()
    }


    const handleScroll = () => {
        if (msgBodyRef.current.scrollTop === 0 && hasMore && !loading) {
            // setOffset(prevOffset => prevOffset + limit);
            setOffset((prevOffset) => {
                const newOffset = prevOffset + limit;
                offsetRef.current = newOffset; // Update offsetRef
                return newOffset;
            });
            setGetUpdatedFeeds(false)
        }
    }

    const closeModal = () => {
        setPromptOpen(false)
    }

    const handleUnblockPromptResponse = async (response) => {
        if (response){
            handleBlockUnblockUser()
            setPromptOpen(false)
        } 
    }

    // When offset is updated, update the ref as well
    useEffect(() => {
        offsetRef.current = offset;
    }, [offset]);

    const getUserChat = async () => {
        try {
            if (loading) return;

            if (oldMessages.length) setLoadMore(true);
            else setLoading(true)

            const response = await getChatMessagesByChannelId(
                channelData?.channelId,
                getUpdatedFeeds && offsetRef.current ? offsetRef.current + limit : limit,
                getUpdatedFeeds ? 0 : offsetRef.current
            )
            if (response) {
                if (getUpdatedFeeds) {
                    setOldMessages([])
                    setOldMessages(response?.data?.data?.chat?.rows)
                    setIsReceipientBlocked(response?.data?.data?.isBlocked ? true : false)
                    handleBlockedChannel(response?.data?.data?.isBlocked ? true : false)

                    setIsSenderBlocked(response?.data?.data?.isBlockedByOtherUser ? true : false)
                    if(!isModal) {
                        isMessageSenderBlocked(response?.data?.data?.isBlockedByOtherUser ? true : false)
                    }

                    if (offsetRef.current) {
                        setGetUpdatedFeeds(false)
                    }
                }
                else {
                    setOldMessages((prev) => [...prev, ...response?.data?.data?.chat?.rows])
                    setGetUpdatedFeeds(true)
                }

                if (offsetRef.current + limit >= response?.data?.data?.chat?.count) {
                    setHasMore(false)
                }
                else {
                    setHasMore(true)
                }

                if (offsetRef.current) {
                    scrollToBottom(100)
                }
                else {
                    scrollToBottom()
                }

                setLoadMore(false);
                setLoading(false)
                dispatch(setAppLoading(false))
                if (refreshData) resetRefreshData(false) //cb for chatbody
            }
        } catch (error) {
            console.log(error)
            setLoading(false)
            dispatch(setAppLoading(false))
        }
    }

    const getChatMemberName = (msgDetails) => {
        if(!msgDetails) return null
        
        if(msgDetails?.senderId === user?.id){
            return getEllipsedString(user?.fullName.split(' ')[0], 10)    
        }
        else{
            return getEllipsedString(selectedChatMember?.user?.fullName.split(' ')[0] ||
            selectedChatMember?.userDetail?.businessName.split(' ')[0], 10)
        }
    }

    useEffect(() => {
        if (isModal) {
            setModalLoading(true); // Show the spinner after 5 seconds
            setTimeout(() => {
                setModalLoading(false); // Show the spinner after 5 seconds
                scrollToBottom()
            }, 2000);
        }
    }, [isModal]);

    useEffect(() => {
        setTimeout(() => {
            if (getUpdatedFeeds === false) getUserChat()
        }, 1000);
    }, [getUpdatedFeeds])

    useEffect(() => {
        msgBodyRef.current.addEventListener('scroll', handleScroll);

        return () => {
            if (msgBodyRef.current) {
                msgBodyRef.current.removeEventListener('scroll', handleScroll);
            }
        };
    }, [handleScroll]);


    useEffect(() => {
        if (selectedChatMemberData || chatData) {
            createNewChatChannel()
            setSelectedChatMember(selectedChatMemberData || chatData)
        }
    }, [chatData, selectedChatMemberData])

    // useEffect(() => {
    //     if (message) formatMessagesByDate()
    // }, [message])

    useEffect(() => {
        if (channelData || refresh || refreshData) {
            if (channelData) {
                setOldMessages([]);
                setGetUpdatedFeeds(true);
                setOffset(0); // Reset offset on new data
                offsetRef.current = 0; // Update offsetRef
            }
            getUserChat();
        }
    }, [channelData, refresh, refreshData])

    useEffect(() => {
        if (channelData) {
            // Event handler for individual chat messages
            const handleChatMessages = (event) => {
                const data = event.detail;
                if (data) {
                    if (data?.channelId && data?.channelId === channelData?.channelId) {
                        const { createdAt, message, isBlocked, channelId } = data
                        
                        let otherUserId;
                        if(isModal){
                            otherUserId = selectedChatMemberData?.id
                        }
                        else{

                            otherUserId = selectedChatMember?.chatMembers.filter(e=>e.memberId !== user?.id)[0]['memberId']
                        }

                        if (isBlocked?.blockeeId !== user?.id) {
                            setOldMessages((prev) => [...prev, { 
                                id: getMessageId(),
                                createdAt, 
                                message, 
                                senderId:otherUserId
                            }])
                            
                            if (socket) {
                                const memberId = user?.id
                                socket.emit("message:read", { channelId, memberId, otherUserId });
                      
                                resetSelectedChannelUnreadMsgCount(channelId)
                            }

                            const audio = new Audio(skypeMp3)
                            audio.play()

                            scrollToBottom()
                        }
                        else {
                            setIsSenderBlocked(true)
                            if(!isModal){
                                isMessageSenderBlocked(true)
                            }
                        }
                    }
                }
            };

            // Attach listener for message:receive
            window.addEventListener("socket:message:receive", handleChatMessages);

            // Cleanup on unmount
            return () => window.removeEventListener("socket:message:receive", handleChatMessages);
        }
    }, [channelData]);

    
    useEffect(() => {
        const handleMessageSeen = (data) => {      
            setTimeout(() => {
                setOldMessages((prevMessages) =>
                    prevMessages.map((msg) => ({
                        ...msg,
                        status: true,
                    }))
                );
            }, 500);
        };
    
        // Register the event listener
        socket.on("message:messageseen", handleMessageSeen);
    
        // Cleanup the event listener on unmount or dependency change
        return () => {
            socket.off("message:messageseen", handleMessageSeen);
        };
    }, []); // Empty dependency array means this runs only on mount/unmount    
    
    
    useEffect(() => {
        formatMessagesByDate()
        oldMessagesRef.current = oldMessages;
    }, [oldMessages])

    const renderBothMembersNotBlocked = () => {
        return (
            <div>
                {
                    !oldMessages.length ? (
                        <div className='text-center'>
                            <p className='text-sm text-gray-300'>Send a message to start chat</p>
                        </div>
                    )
                    : ''
                }
                <ChatInput
                    chatData={{
                        channelId: channelData?.channelId,
                        senderId: user?.id,
                        receiverId: selectedChatMember?.memberId || selectedChatMember?.id
                    }}
                    newUserMessage={(newUserMsg) => handleUserMsgInput(newUserMsg)}
                />
            </div>
        )
    }

    const renderReceipientBlocked = () => {
        return (
            <div className='bg-black text-white p-4 flex flex-col justify-center items-center'>
                <p className='text-sm mb-2'>Would you like to start conversation with this user?</p>
                <div className='flex'>
                    <div
                        className='bg-[#FF1D6A] px-4 py-2 rounded-sm text-xs cursor-pointer'
                        onClick={() =>
                            isReceipientBlocked ?
                                setPromptOpen(true) :
                                handleBlockUnblockUser()
                        }
                    >
                        {isReceipientBlocked ? 'Unblock' : 'Block'}
                    </div>
                </div>
            </div>
        )
    }

    const renderSenderBlocked = () => {
        return (
            <div className='bg-black text-white p-4 flex flex-col justify-center items-center'>
                <p className='text-sm mb-2'>You cannot continue this conversation</p>
            </div>
        )
    }

    const renderReceipientNotAcceptRequest = () => {
        return (
            <div className='bg-black text-white p-4 flex flex-col justify-center items-center'>
                <p className='text-xs mb-3'>Would you like to start conversation with this user?</p>
                <div className='flex'>
                    <div
                        className='rounded-md bg-blue-500 px-4 py-2 mr-4 rounded-sm text-xs cursor-pointer'
                        onClick={handleAcceptUserChatRequest}
                    >
                        Accept
                    </div>
                    <div
                        className='rounded-md bg-[#FF1D6A] px-4 py-2 rounded-sm text-xs cursor-pointer'
                        onClick={() =>
                            isReceipientBlocked ?
                                setPromptOpen(true) :
                                handleBlockUnblockUser()
                        }
                    >
                        {isReceipientBlocked ? 'Unblock' : 'Block'}
                    </div>
                </div>
            </div>  
        )
    }

    return (
        <React.Fragment>
            <div
                className={`overflow-y-auto ${!isModal && 'sm:max-h-[75vh]'} max-h-[50vh] pt-2 msgs`}
                ref={msgBodyRef}
            >
                {loadMore && (
                    <div className='flex justify-center items-center mb-4'>
                        <Spin indicator={<LoadingOutlined className='text-black' spin />} size="medium" />
                    </div>
                )}
                {
                    !modalLoading && dateTimeFormattedMsgs &&
                        Object.keys(dateTimeFormattedMsgs).length ?
                        Object.keys(dateTimeFormattedMsgs).map((date, dIdx) => (
                            <div key={'date' + dIdx} className='text-center'>
                                <div className='relative'>
                                    <div className='border border-gray-200 h-[1px]'></div>
                                    <h5 className='heading-5 sm:text-sm text-[12px] font-normal text-gray-300 absolute top-[-11px] left-1/2 bg-white px-2
                                        transform -translate-x-1/2'>
                                        {
                                            getFormattedDateTime(date, 'YYYY-MM-DD') === currentDate ?
                                                'Today' :
                                                getFormattedDateTime(date, 'dddd, MMMM D')
                                        }
                                    </h5>
                                </div>
                                <div className='py-4'>
                                    {
                                        dateTimeFormattedMsgs[date].map(msg => (
                                            <div
                                                className={`flex 
                                                    ${msg?.senderId === user?.id ? 'justify-end' : 'justify-start'} item-start p-2`
                                                }
                                                key={'msg' + msg?.id}
                                            >
                                                <div
                                                    className={`
                                                        rounded-full w-[45px] h-[45px] mt-2
                                                        ${msg?.senderId !== user?.id ? 'order-1' : 'order-2'}`
                                                    }
                                                >
                                                    <Avatar
                                                        src={
                                                            msg?.senderId === user?.id ? user?.imageThumbUrl :
                                                                selectedChatMember?.user?.imageThumbUrl || selectedChatMember?.imageThumbUrl
                                                        }
                                                        className='w-full h-full object-contain'
                                                    >
                                                        {(msg?.senderId === user?.id ? user?.fullName :
                                                            selectedChatMember?.user?.fullName || selectedChatMember?.fullName
                                                        )?.charAt(0)?.toUpperCase()}
                                                    </Avatar>
                                                </div>
                                                <div
                                                    className={`flex flex-col p-2 ml-2
                                                        ${msg?.senderId !== user?.id ? 'order-2' : 'order-1'}    
                                                    `}
                                                >
                                                    <div className={`flex ${msg?.senderId !== user?.id ? 'justify-start' : 'justify-end'}`}>
                                                        {!isModal ? (
                                                            <h6 className={`heading-6 font-bold text-md mb-[5px] mr-2`}>
                                                                {
                                                                    getChatMemberName(msg)
                                                                }
                                                            </h6>
                                                        ) : ''}
                                                        <p className={`text-xs pt-1 inline-block mb-[5px] text-slate-400`}>
                                                            {getFormattedDateTime(msg?.createdAt, "h:mm A")}
                                                        </p>
                                                    </div>
                                                    <div
                                                        className={`
                                                            ${isModal ? 'rounded-xl max-w-[200px]' : 'sm:max-w-[400px] max-w-[250px]'}
                                                            ${msg?.senderId === user?.id && isModal ? 'bg-black' :
                                                                msg?.senderId !== user?.id && isModal ? 'bg-slate-100' : ''
                                                            }`
                                                        }
                                                    >
                                                        <div className={`flex justify-between items-end rounded-lg p-3 pl-3 pr-2
                                                            ${msg?.senderId === user?.id ? 'bg-black' : 'bg-slate-100'}`}>
                                                            <div className='w-auto'>
                                                                <p className={`whitespace-pre-wrap break-words leading-[1.1rem] text-xs
                                                                    ${msg?.senderId === user?.id && 'text-white'}`}>
                                                                    {msg?.message}
                                                                </p>
                                                            </div>
                                                            { msg?.senderId === user?.id ? (
                                                            <div className='flex justify-end w-[40px]'>
                                                                <IoCheckmarkDoneSharp 
                                                                    className={`${msg?.status ? 'text-blue-400' : 'text-gray-300'}`} 
                                                                />
                                                            </div>
                                                            ) : null }
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        ))
                                    }
                                </div>
                            </div>
                        )) : ''
                }
            </div>

            {!modalLoading ? //if loading stopped
                selectedChatMember && channelData ?
                    channelData?.status ? //if receipient msg request accepted
                        !isSenderBlocked && !isReceipientBlocked ?  //if sender and receiver have not blocked each other
                        renderBothMembersNotBlocked()
                        : !isSenderBlocked && isReceipientBlocked ?  //if sender not blocked but receipient blocked
                        renderReceipientBlocked()    
                        : renderSenderBlocked()  //if sender is blocked
                    : renderReceipientNotAcceptRequest() //if receipient msg request not accepted
                    : null
                : (
                    <div className='flex justify-center items-center mb-4'>
                        <Spin indicator={<LoadingOutlined className='text-black' spin />} size="medium" />
                    </div>
                )
            }

            <Modal.Basic
                id='unlockUserPrompt'
                open={promptOpen}
                onCancel={closeModal}
                width={250}
            >
                <Prompt.Basic
                    message={unlockUserPromptMessage}
                    onChange={handleUnblockPromptResponse}
                    closeModal={closeModal}
                />
            </Modal.Basic>
        </React.Fragment>
    )
}

export default ChatMessages